import { HttpClient } from '@angular/common/http';
import { AppConstants } from '../shared/app.constants';
import { AuthService } from '../auth.service';
import { environment } from '../../environments/environment';
var InvoiceService = /** @class */ (function () {
    function InvoiceService(http, appConstants, auth) {
        this.http = http;
        this.appConstants = appConstants;
        this.auth = auth;
    }
    InvoiceService.prototype.getAllInvoices = function () {
        var url = environment.apiBase + 'invoices';
        var headers = this.auth.getAuthorizationHeaders();
        return this.http.get(url, { headers: headers }).map(function (res) { return res; }).catch(this.appConstants.errorHandler);
    };
    InvoiceService.prototype.updateInvoice = function (body) {
        var url = environment.apiBase + ("invoices/" + body.id);
        var headers = { headers: this.auth.getAuthorizationHeaders() };
        return this.http.put(url, body, headers).map(function (res) { return res; }).catch(this.appConstants.errorHandler);
    };
    InvoiceService.prototype.approveInvoice = function (body) {
        var url = environment.apiBase + 'invoices/accept';
        var headers = { headers: this.auth.getAuthorizationHeaders() };
        return this.http.post(url, body, headers).map(function (res) { return res; }).catch(this.appConstants.errorHandler);
    };
    return InvoiceService;
}());
export { InvoiceService };



// WEBPACK FOOTER //
// /Users/Chetan/Downloads/angular5_admin-master/src/app/invoices/invoice.service.ts.pre-build-optimizer.js